import { Component, OnInit, Input, ViewChild, ElementRef, trigger, transition, style, animate, state } from '@angular/core';
import { EBEpouchdbService } from '../../../EBE/EBEpouchdb.service';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BookData } from '../../../shared/models/bookData';
import { Page } from '../../../shared/models/page';
import * as _ from 'lodash';
import { ExportContent } from '../../../shared/models/ExportContent';
import { Http, Headers, Request, Response, RequestOptions } from '@angular/http';
import { ExportService } from './exoprt.service'
import { PageContent } from '../../../shared/models/pageContent';
import { MatSnackBar } from '@angular/material';
import { Export } from '../../../shared/models/export';
import { Constants } from '../../../shared/models/constants';
import { Book } from '../../../shared/models/book';
import { GoogleService } from '../../../shared/Google.service';
import { IS_ElectronService } from '../../../shared/IS_Electron.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
declare var gapi: any;

// import * as cloneDeep from 'lodash/cloneDeep';

var CANVAS;

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            animate('500ms', style({ height: 'auto' }))
          ]
        ),
        transition(
          ':leave', [
            animate('500ms', style({ height: '0' })),
          ]
        )
      ]
    )
  ],
})
export class ExportviewComponent implements OnInit {
  @Input() data: any;
  @Input() exportGlobalData: any
  public selectedFilters = [];
  BookPagesNo: any = [];
  pdfPagesNo: any = [];
  pageObj: any = {};
  totalpdfpage;
  bookDataObj: BookData;
  bookObj: Book;
  pageCount;
  pages = [];
  currentSelectedPageToShowEnrichs = [];
  isLoader = false;
  show2nddata = undefined;
  show3nddata = undefined;
  show4nddata = undefined;
  openSubMenu = false;
  openSubMenu1 = false;
  openSubMenu3 = false;
  openNotesMenu = false;
  paddingleftCount = 5;
  selectedPageData: any;
  public localDB;
  public exportContentArray = {

  };
  public searchContact;
  public exportTitle = 'Title';
  public exportDescription = 'Description';
  public formTreeArray = [];
  public ShareList = [];
  public sharedata;
  googlechilderen = [];
  currentContent: any;
  folderid;
  type;
  exportdata = [];
  myfolderid;
  filesdata: any;

  mindMapModel: any;
  showEnrichmentsDiv = false;
  showContactsList = false;
  CEcomponent = false;
  public selectedContactIndex;
  public exportSubscription: any;
  public checkedValue = false;
  pageContentResult: any;
  mydata = [];
  contactlist;
  public wholeenrichment_pagecount;
  isGlobalExport;
  @ViewChild('uploadExport', { read: ElementRef }) public uploadExport: ElementRef;
  constructor(public googleservice: GoogleService, public http: Http, public snackBar: MatSnackBar, public mainPouchService: ExportService, private ele: ElementRef, private pouchService: EBEpouchdbService, private sanitizer: DomSanitizer, private ElectronService: IS_ElectronService, private translate: TranslateService) {

    // this.localDB = mainPouchService.localDB;

  }


  ngOnInit() {

    if (this.exportGlobalData) {
      if (this.data == undefined) {
        this.data = this.exportGlobalData;
        // this.data.popupProps.bookDataObj
        this.isGlobalExport = this.exportGlobalData.popupProps.isGlobalExport;
      }

    }

    if (this.data) {
      if (this.data.popupProps.CE == true) {

        this.showEnrichmentsDiv = false;
        this.showContactsList = true;
        this.CEcomponent = true;
      }
    }

    if (this.data && this.data.popupProps) {

      this.bookDataObj = _.cloneDeep(this.data.popupProps.bookDataObj);
      this.pageCount = this.data.popupProps.pageCount;
      // var deep = _.cloneDeep(objects);
      this.bookObj = _.cloneDeep(this.data.popupProps.bookObj);



      // if (this.data.popupProps.CE == true) {
      //   this.preapreExportContentForCreated();
      // }


      //To create static pages array

      for (let i = 0; i < this.pageCount; i++) {

        if (this.bookDataObj[i + 1]) {

          this.pages.push(this.bookDataObj[i + 1]);

          if (this.bookDataObj[i + 1].enrichment_page.length > 0 || this.bookDataObj[i + 1].notes.length > 0)

            this.selectedFilters.push(this.bookDataObj[i + 1]);
        }


      }

      for (var i = 1; i <= this.selectedFilters.length; i++) {
        if (i < 10) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-00" + i + ".JPG";
        }
        else if (i == 10) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-010.JPG";

        }
        else if (i == 100) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-100.JPG";

        }
        else if (i > 100) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-" + i + ".JPG";
        }
        else {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-0" + i + ".JPG";
        }
        this.selectedFilters[i - 1].url = url;

      }
    }
    const headers = new Headers();
    headers.append('Authorization', 'Bearer' + localStorage.userToken);
    const options = new RequestOptions({ headers: headers });
    var self = this;

    // this.http.post(
    //   "http://" + Constants.nasUrl, {
    //     "query": 'query{ appPremissions, {directExport, organizationId, appFeatures,{ id, featuresType} contacts{user, { id, name, type, email }} }}',
    //   }, options
    // ).subscribe(
    //   res =>
    //     self.GetContactList(res.json().data)
    // );


    this.ShareList = JSON.parse(localStorage.contacts);
    this.dummyShareList = _.cloneDeep(this.ShareList);


    this.exportSubscription = this.ElectronService.isExport$.subscribe(message => {
      if (message)
        this.uploadExportFileToDriveInElectron(message);
    });

  }
  ngOnDestroy() {
    if (this.exportSubscription)
      this.exportSubscription.unsubscribe();
  }

  // GetContactList(contact) {
  //   this.ShareList = contact.appPremissions.contacts;
  //   this.dummyShareList = _.cloneDeep(this.ShareList);
  // }

  gotoPageEnrichments(page, i, event) {
    if (i == 'tick') {
      event.stopPropagation();
      this.selectWholePage(page);
      this.openCloseTab1('', 0, page);
      this.openSubMenu = true;
      this.openNotesMenu = true;
      return
    }


    var array = page;
    this.selectedPageData = page;
    this.currentSelectedPageToShowEnrichs = [];
    this.showEnrichmentsDiv = true;
    this.currentSelectedPageToShowEnrichs.push(array);
    this.openCloseTab1('', 0, this.currentSelectedPageToShowEnrichs[0]);
    this.openSubMenu = true;
    this.openNotesMenu = true;
  }

  openCloseTab1(evt, ind, pgdata) {
    for (let m = 0; m < pgdata.enrichment_page.length; m++) {
      pgdata.enrichment_page[m].isChildrenShow = true;
      pgdata.enrichment_page[m].showToggleIcon = false;
    }
    if (ind != this.show2nddata && this.openSubMenu == true) {
      this.openSubMenu = !this.openSubMenu;
    }
    this.openSubMenu = !this.openSubMenu;
    this.show2nddata = ind;
    // this.showToggleIcon = !this.showToggleIcon;
  }


  openCloseTab2(evt, ind, pgdata) {

    this.openNotesMenu = !this.openNotesMenu;

  }

  showHideChildren(event, nodeData, parentData) {
    for (var c = 0; c < parentData.length; c++) {
      //  parentData[c].color = '';
      // parentData[c].padingLft = '0';
    }
    for (var q = 0; q < nodeData.children.length; q++) {
      // nodeData.children[q].color = 'red';
      // nodeData.children[q].padingLft = "20";
      nodeData.children[q].isChildrenShow = true;
      nodeData.children[q].showToggleIcon = false;
    }
    event.stopPropagation();
    nodeData.isChildrenShow = !nodeData.isChildrenShow
    nodeData.showToggleIcon = !nodeData.showToggleIcon;

  }


  toggleEnrichmentCheck(event, nodeData, parentData, ind) {

    if (nodeData.isChecked == true) {
      nodeData.isChecked = false;

      this.unselectWholePage(this.selectedPageData);

    }

    else {
      nodeData.isChecked = true;

    }

    if (nodeData.children.length > 0) {

      this.updateCheckPropertyForchilds(nodeData.isChecked, nodeData.children);
    }
  }

  toggleNotesCheck(event, nodeData, parentData) {
    if (nodeData.isChecked == true) {
      nodeData.isChecked = false;

      this.unselectWholePage(this.selectedPageData);

    }
    else {
      nodeData.isChecked = true;
    }

  }

  unselectWholePage(page) {

    page.isPageChecked = false;

  }


  selectWholePage(page) {

    if (page.isPageChecked == true) {
      page.isPageChecked = false;

      _.forEach(page.enrichment_page, function (enrichPage) {
        enrichPage.isChecked = false;

      })

      _.forEach(page.notes, function (notes) {
        notes.isChecked = false;

      })
    }

    else {
      page.isPageChecked = true;

      _.forEach(page.enrichment_page, function (enrichPage) {
        enrichPage.isChecked = true;

      })

      _.forEach(page.notes, function (notes) {
        notes.isChecked = true;

      })

    }





  }


  updateCheckPropertyForchilds(state, obj) {

    for (var i = 0; i < obj.length; i++) {

      obj[i].isChecked = state;

      if (obj[i].children.length > 0) {

        this.updateCheckPropertyForchilds(state, obj[i].children)
      }

    }

  }

  updateunCheckPropertyForchilds(state, id, obj) {

    for (var i = 0; i < obj.length; i++) {

      if (obj[i].id == id) {

      }

      else {
        if (obj[i].children.length > 0) {
          obj[i].isChecked = state;

          this.updateunCheckPropertyForchilds(state, id, obj[i].children)
        }

      }

    }

  }

  goBackToEnrichmentsView() {

    if (this.clickedNextFromFirstPage == true) {
      this.showEnrichmentsDiv = false;
      this.showContactsList = false;

    }

    else {

      this.showContactsList = false;
      this.showEnrichmentsDiv = true;
    }

    this.clickedNextFromFirstPage = false;
  }

  goBackToPagesView() {

    this.showEnrichmentsDiv = false;
    this.showContactsList = false;
    for (let m = 0; m < this.selectedPageData.enrichment_page.length; m++) {
      this.selectedPageData.enrichment_page[m].isChildrenShow = true;
      this.selectedPageData.enrichment_page[m].showToggleIcon = false;
    }
  }
  public exportContent = new ExportContent();
  public checkedPageObj;
  public clickedNextFromFirstPage = false;

  gotoContactsPageFromMainPage() {
    var count = 0;
    for (var i = 0; i < this.selectedFilters.length; i++) {

      if (this.selectedFilters[i].isPageChecked == true) {
        count++;
      }
    }


    if (count == 0) {

      this.openSnackBar('There is nothing to export', '');

      return;
    }


    this.clickedNextFromFirstPage = true;

    this.showContactsList = true;
    this.showEnrichmentsDiv = false;

  }

  gotoContactsPage() {


    this.showContactsList = true;
    this.showEnrichmentsDiv = false;

  }
  notesProp: any;
  formNotesArray() {

    var self = this;
    for (var i = 0; i < this.exportContent.page.length; i++) {

      var notes = _.filter(this.exportContent.page[i].notes, function (o) {

        self.notesProp = o;
        return self.notesProp.isChecked == true
      });

      this.exportContent.page[i].notes = notes;

    }

    // this.showContactsList = true;
    // this.showEnrichmentsDiv = false;
  }


  iteratePropertiesInBookdataObj() {
    this.exportContent = new ExportContent;
    for (var property in this.bookDataObj) {
      if (this.bookDataObj[property] != undefined) {
        if (this.bookDataObj[property].enrichment_page)
          if (this.bookDataObj[property].enrichment_page.length > 0) {

            // if(this.bookDataObj[property].enrichment_page)
            this.checkedPageObj = this.formPageObj(this.bookDataObj[property]);

            this.updatePageObjectInchildren(this.bookDataObj[property].enrichment_page, '1', this.checkedPageObj);
            if (this.checkedValue == true) {

              this.exportContent.page.push(this.checkedPageObj);
              this.checkedValue = false;
            }


            if (this.exportContent.page.length == 0) {

              if (this.bookDataObj[property].notes)
                if (this.bookDataObj[property].notes.length > 0) {
                  this.checkedPageObj = this.formPageObj(this.bookDataObj[property]);

                  this.exportContent.page.push(this.checkedPageObj);
                }

            }

          }

      }
    }



    if (this.exportContent.page.length == 0) {

      this.openSnackBar('There is nothing to export', '');

      return;
    }

    this.formNotesArray();
  }


  updatePageObjectInchildren(item, level, parentObj) {
    for (var i = 0; i < item.length; i++) {
      if (item[i].isChecked == true) {

        this.checkedValue = true;

        var obj = _.cloneDeep(item[i]);
        obj.isChecked = undefined
        if (level == '1') {
          obj.enrichment_page = [];
          // obj.children = [];
          parentObj.enrichment_page.push(obj);
        }

        else {
          obj.children = [];

          if (parentObj.enrichment_page) {
            if (parentObj.enrichment_page.length == 0)
              parentObj.enrichment_page.push(obj);
            else parentObj.enrichment_page[parentObj.enrichment_page.length - 1].children.push(obj);

          }

          else parentObj.enrichment_page[parentObj.enrichment_page.length - 1].children.push(obj);

        }


        this.iterateAndGetPagecontent(obj);
        this.showContactsList = true;
        this.showEnrichmentsDiv = false;


      }

      // if (item[i].children.length > 0) {

      //   this.updatePageObjectInchildren(item[i].children, '', parentObj)
      // }
    }




  }
  iterateAndGetPagecontent(obj) {

    if (obj.type == 'blankPage' || obj.type == 'template' || obj.type == 'duplicateAsImage' || obj.type == 'duplicateAsPage' || obj.type == 'pageFromBook') {

      var pageContent = new PageContent();
      pageContent._id = obj.contentDocId

      this.mainPouchService.getPageContent(obj.contentDocId, pageContent, this);

    }

    if (obj.children.length > 0) {

      for (var i = 0; i < obj.children.length; i++) {

        this.iterateAndGetPagecontent(obj.children[i])
      }
    }
  }

  formPageObj(formPageObj) {

    var page = new Page();

    page.annotations = formPageObj.annotations;
    page.bookmarks = formPageObj.bookmarks;
    page.drawing = formPageObj.drawing;
    page.contentDocId = formPageObj.contentDocId;
    page.pageNumber = formPageObj.pageNumber;
    page.title = formPageObj.title;
    page.notes = formPageObj.notes;
    page.id = formPageObj.id;
    page.type = formPageObj.type;
    page.pageNumber = formPageObj.pageNumber;
    page.description = formPageObj.description;

    return page;
  }

  updatePageContent(result) {

    this.exportContent.content.push(result);

    this.updateExportContentForElectron();

    if (this.exportContent.page.length == 0) {


      this.openSnackBar('There is nothing to export', '');

      return;
    }

  }
  updateExportContentForElectron() {
    var enrichment_pagecount = 0;

    for (var j = 0; j < this.exportContent.page.length; j++) {


      if (this.exportContent.page[j].type == 'blankPage' || this.exportContent.page[j].type == 'template' || this.exportContent.page[j].type == 'pageFromBook' || this.exportContent.page[j].type == 'duplicateAsPage' || this.exportContent.page[j].type == 'duplicateAsImage') {
        if (this.bookObj.bookCategory == 1) enrichment_pagecount++;
      }

      if (this.exportContent.page[j].enrichment_page.length > 0) {

        for (var m = 0; m < this.exportContent.page[j].enrichment_page.length; m++) {

          if (this.exportContent.page[j].enrichment_page[m].type == 'blankPage' || this.exportContent.page[j].enrichment_page[m].type == 'template'
            || this.exportContent.page[j].enrichment_page[m].type == 'pageFromBook' || this.exportContent.page[j].enrichment_page[m].type == 'duplicateAsPage'
            || this.exportContent.page[j].enrichment_page[m].type == 'duplicateAsImage') {
            enrichment_pagecount++;
          }

          if (this.exportContent.page[j].enrichment_page[m].children.length > 0) {
            this.getContentLength(this.exportContent.page[j].enrichment_page[m], enrichment_pagecount);
          }

        }
      }
    }

    if (this.bookObj.bookCategory == 1) {
      if (this.exportContent.content.length == enrichment_pagecount) {
        if (this.ElectronService.IS_ELECTRON) {
          this.parseElectronPageAssets();
        }
        else this.getWholeEnrichmentCount(enrichment_pagecount)
      }

    }
    else {
      if (this.exportContent.content.length == enrichment_pagecount) {
        if (this.ElectronService.IS_ELECTRON) {
          this.parseElectronPageAssets();
        }
        else this.getWholeEnrichmentCount(enrichment_pagecount)
      }

    }


  }
  getContentLength(data, enrichment_pagecount) {
    for (var k = 0; k < data.children.length; k++) {

      if (enrichment_pagecount + data.children[k].type == 'blankPage' || enrichment_pagecount + data.children[k].type == 'template'
        || enrichment_pagecount + data.children[k].type == 'pageFromBook' || enrichment_pagecount + data.children[k].type == 'duplicateAsPage'
        || enrichment_pagecount + data.children[k].type == 'duplicateAsImage') {
        enrichment_pagecount++;
      }
      if (data.children[k].children.length > 0) {

        this.getContentLength(data.children[k], enrichment_pagecount);

      }

    }
  }


  getWholeEnrichmentCount(count) {
    this.wholeenrichment_pagecount = count;
    this.uploadtoDriveAndPrepareJson()

  }


  openSnackBar(message: string, action: string) {

    let self = this;

    this.translate.get(message).subscribe((res) => {
      self.snackBar.open(res, action, {
        panelClass: ['snack-bar-color'],
        duration: 2000,
      });
    });

  }


  selectContactToShare(contact, ind) {
    var r = _.findIndex(this.mydata, function (o) { return o.user.name == contact; });
    contact.user.isChecked = !contact.user.isChecked;
    if (contact.user.isChecked) {
      this.mydata.push(contact)
    }
    else {
      var r = _.findIndex(this.mydata, function (o) { return o.user.id == contact.user.id; });
      this.mydata.splice(r, 1)

    }

  }
  prepareExportJson(id) {
    var exportjson = new Export;
    exportjson.description = this.exportDescription;
    exportjson.bId = this.bookObj.bId;
    exportjson.book = this.bookObj;
    exportjson.time = Math.round(new Date().getTime() / 1000);
    exportjson.title = this.exportTitle;
    exportjson._id = Constants.USER + "." + Constants.getGUID() + '.export';
    exportjson.contentURL = id;

    // exportjson.enrichmentCount = this.exportContent.enrichment_page.length;+
    var enrichment_pagecount = 0;
    var notesCount = 0;
    for (var j = 0; j < this.exportContent.page.length; j++) {

      enrichment_pagecount = enrichment_pagecount + this.exportContent.page[j].enrichment_page.length;
      notesCount = notesCount + this.exportContent.page[j].notes.length;

    }

    exportjson.sender = JSON.parse(localStorage.userData).name;

    // exportjson.enrichmentCount = enrichment_pagecount;


    // exportjson.notesCount = notesCount;
    // exportjson.count = exportjson.enrichmentCount + exportjson.notesCount
    exportjson.count = notesCount + enrichment_pagecount;
    var obj = []

    for (var i = 0; i < this.mydata.length; i++) {
      var temp = JSON.parse(localStorage.nasResponse)

      obj.push(temp.signIn.organizationId + '_' + this.mydata[i].user.id);

    }

    exportjson.recipients = obj;

    this.exportdata.push(this.exportContent);
    if (exportjson.recipients.length == 0) {
      this.openSnackBar('Select Contacts to export', '');
      return;
    }
    if (!this.ElectronService.IS_ELECTRON)
      this.parsePageAssets();

    this.mainPouchService.updateExportToPouchdb(exportjson);

  }

  parseElectronPageAssets() {
    var assetsThumbnails = [];
    for (var i = 0; i < this.exportContent.content.length; i++) {
      this.currentContent = this.exportContent.content;
      if (this.currentContent[i].pageContent && this.currentContent[i].pageContent.pageAssets) {
        if (this.currentContent[i].pageContent.pageAssets.length > 0) {
          this.currentContent[i].pageContent.pageAssets.forEach(pageAsset => {
            assetsThumbnails.push(pageAsset);
          });
        }
        if (this.currentContent[i].pageContent.pageBgStyle)
        {
          var img = this.currentContent[i].pageContent.pageBgStyle.url;
          if(img.indexOf('http') !=0)
          assetsThumbnails.push(img);
        }
      }
    }
    if (assetsThumbnails.length > 0)
      this.ElectronService.insertPageAssetsintoExportFolder(assetsThumbnails);

    else
      this.uploadExportFileToDriveInElectron(false);
  }
  parsePageAssets() {
    var assetsThumbnails = [];
    for (var i = 0; i < this.exportContent.content.length; i++) {
      //JSON.parse(this.exportContent.content[i].pageContent)
      this.currentContent = this.exportContent.content

      if (this.currentContent[i].pageContent) {
        if (this.currentContent[i].pageContent.pageAssets)
          if (this.currentContent[i].pageContent.pageAssets.length > 0) {
            this.sharedata = this.currentContent[i].pageContent.pageAssets;
            if (this.googleservice.googlechilderen != undefined) {
              var googlemedia = this.googleservice.googlechilderen;
            }
            else {
              var id
              this.googleservice.retrieveAllFilesInFolder(id, this, this.sharedata)
            }
            try {
              this.googleservice.googlechilderen.forEach(element1 => {
                this.sharedata.forEach(element => {
                  element = element.replace("https://lh3.google.com/u/0/d/", "")
                  if (element == element1.id)
                    this.googlechilderen.push(element1)

                });
              });
              // this.Createjson()
              console.log(this.googlechilderen)
            }

            catch (ex) {
              // this.Createjson()
            }




          }
          else {

          }
      }
    }

  }

  Createjson(parentid) {
    let that = this
    const boundary = '-------314159265358979323846';
    const delimiter = "\r\n--" + boundary + "\r\n";
    const close_delim = "\r\n--" + boundary + "--";

    const contentType = 'application/json';
    var data = JSON.stringify(this.exportdata)
    var metadata = {
      'title': "Contentdata",
      'mimeType': contentType

    };

    var multipartRequestBody =
      delimiter +
      'Content-Type: application/json\r\n\r\n' +
      JSON.stringify(metadata) +
      delimiter +
      'Content-Type: ' + contentType + '\r\n\r\n' +
      data +
      close_delim;

    var request = gapi.client.request({
      'path': '/upload/drive/v2/files',
      'method': 'POST',
      'params': { 'uploadType': 'multipart' },
      'headers': {
        'Content-Type': 'multipart/related; boundary="' + boundary + '"'
      },
      'body': multipartRequestBody
    });

    request.execute(function (resp) {
      that.googlechilderen.push(resp);
      that.copyfile(parentid);
    });

  }


  Exportfile() {
    if (this.mydata.length == 0) {
      this.openSnackBar('Select Contacts to Export', '');
      return;
    }
    this.isLoader = true;
    if (this.data.popupProps.CE == true) {
      this.preapreExportContentForCreated();
    }

    else {

      this.iteratePropertiesInBookdataObj();

    }


  }
  uploadExportFileToDriveInElectron(state) {

    if (this.mydata.length == 0) {
      this.openSnackBar('Select Contacts to Export', '');
      return;
    }

    this.isLoader = true;
    let that = this
    var body = {
      // 'title': 'Sharefile',
      'title': this.exportTitle + '_' + Math.round(new Date().getTime() / 1000),
      'mimeType': "application/vnd.google-apps.folder"
    };

    var request = gapi.client.drive.files.insert({
      'resource': body
    });

    var self = self;
    request.execute(function (resp) {
      if (state) {
        var arraybuffer = that.ElectronService.FS.readFileSync(that.ElectronService.USER_PATH + '/Export.zip');
        let binary = '';
        let bytes = new Uint8Array(arraybuffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        let filesdata = window.btoa(binary);
        that.uploadExportZipToDriveInElectron(filesdata, resp.id);
      }
      that.prepareExportJson(resp.id);
      that.Createjson(resp.id);
      that.data.popupProps.showPopup = false;
      that.data.popupProps.curComp.selectedExportIconIndex = undefined;
      that.isLoader = false;

    });

  }
  uploadExportZipToDriveInElectron(arraybuffer, parentid) {
    let that = this
    const boundary = '-------314159265358979323846';
    const delimiter = "\r\n--" + boundary + "\r\n";
    const close_delim = "\r\n--" + boundary + "--";

    const contentType = 'application/zip';
    //var data = JSON.stringify(this.exportdata)
    var metadata = {
      'title': "Exportdata.zip",
      'mimeType': 'application.zip',
      'parents': [{ 'id': parentid }]

    };
    var multipartRequestBody =
      delimiter +
      'Content-Type: application/json\r\n\r\n' +
      JSON.stringify(metadata) +
      delimiter +
      'Content-Type: ' + contentType + '\r\n' +
      'Content-Transfer-Encoding: base64\r\n' +
      '\r\n' +
      arraybuffer
      +
      close_delim;

    var request = gapi.client.request({
      'path': '/upload/drive/v2/files',
      'method': 'POST',
      'params': { 'uploadType': 'multipart' },
      'headers': {
        'Content-Type': 'multipart/related; boundary="' + boundary + '"'
      },
      'body': multipartRequestBody
    });

    request.execute(function (resp) {
      that.googleservice.insertPermission(resp.id)

    });

  }
  uploadtoDriveAndPrepareJson() {
    let that = this
    var body = {
      // 'title': 'Sharefile',
      'title': this.exportTitle + '_' + Math.round(new Date().getTime() / 1000),
      'parents': [{ 'id': localStorage.currentDriveId }],
      'mimeType': "application/vnd.google-apps.folder"
    };

    var request = gapi.client.drive.files.insert({
      'resource': body
    });

    var self = self;
    request.execute(function (resp) {

      that.prepareExportJson(resp.id)
      that.insertporperty(resp.id)
      that.Createjson(resp.id)
      that.myfolderid = resp.id
    });

  }

  preapreExportContentForCreated() {
    var self = this;

    this.exportContent = new ExportContent;
    for (var property in this.bookDataObj) {
      if (this.bookDataObj[property] != undefined) {
        if (this.bookDataObj[property].isPage) {
          this.exportContent.page.push(this.bookDataObj[property]);
          if (this.bookDataObj[property].type == 'blankPage' || this.bookDataObj[property].type == 'template' || this.bookDataObj[property].type == 'duplicateAsImage' || this.bookDataObj[property].type == 'duplicateAsPage' || this.bookDataObj[property].type == 'pageFromBook') {

            var pageContent = new PageContent();
            pageContent._id = this.bookDataObj[property].contentDocId;

            this.mainPouchService.getPageContent(this.bookDataObj[property].contentDocId, pageContent, this);

            if (self.bookDataObj[property].enrichment_page.length > 0) {

              self.pushPageContentToExportContentForCE(self.bookDataObj[property].enrichment_page);
            }
            if (self.bookDataObj[property].children)
              if (self.bookDataObj[property].children.length > 0) {

                self.pushChildrenPageContentToExport(self.bookDataObj[property].children);
              }
          }

        }
      }

    }
  }
  pushChildrenPageContentToExport(obj) {
    var self = this;
    for (var i = 0; i < obj.length; i++) {

      var pageContent = new PageContent();
      pageContent._id = obj[i].contentDocId;

      this.mainPouchService.getPageContent(obj[i].contentDocId, pageContent, this);

      if (obj[i].enrichment_page.length > 0) {

        self.pushPageContentToExportContentForCE(obj[i].enrichment_page);
      }

      if (obj[i].children.length > 0) {
        this.pushChildrenPageContentToExport(obj[i].children)
      }

    }
  }

  pushPageContentToExportContentForCE(obj) {
    var self = this;
    for (var i = 0; i < obj.length; i++) {

      var pageContent = new PageContent();
      pageContent._id = obj[i].contentDocId;

      this.mainPouchService.getPageContent(obj[i].contentDocId, pageContent, this)

      if (obj[i].children.length > 0) {
        this.pushPageContentToExportContentForCE(obj[i].children)
      }

    }

  }
  insertporperty(id) {
    let that = this
    var body = {
      'key': 'shareID',
      'value': "sharetomedia",
      'visibility': 'public'
    }
    var request = gapi.client.drive.properties.insert({
      'fileId': id,
      'resource': body
    });
    request.execute(function (resp) {
      console.log(resp)
    });
  }
  copyfile(parentid) {
    this.isLoader = false;
    let that = this

    if (this.googlechilderen.length > 0) {
      this.googlechilderen.forEach(element => {
        var body = {
          'title': element.title, 'parents': [{ 'id': parentid }]
        };
        var request = gapi.client.drive.files.copy({
          'fileId': element.id,
          'resource': body
        });
        request.execute(function (resp) {
          console.log('Copy ID: ' + resp.id);
          var email;
          var emails;
          that.contactlist = _.map(that.mydata, 'user.email')
          that.googleservice.Sharefile(parentid, email, that.contactlist, 'reader');

          if (that.isGlobalExport == true) {

            that.mainPouchService.closeExport();
          }

          else {
            that.data.popupProps.showPopup = false;
            that.data.popupProps.curComp.selectedExportIconIndex = undefined;
          }


        });
      })
    }

    else {
      var email;
      var emails;
      that.contactlist = _.map(that.mydata, 'user.email')
      that.googleservice.Sharefile(parentid, email, that.contactlist, 'reader');


      if (that.isGlobalExport == true) {

        that.mainPouchService.closeExport();
      }

      else {

        that.data.popupProps.showPopup = false;
        that.data.popupProps.curComp.selectedExportIconIndex = undefined;
      }


    }

  }

  dummyShareList = [];

  searchContactsForFilter(e, searchkey) {
    var self = this;

    // this.dummyShareList = _.cloneDeep(self.ShareList);

    if (e.length == 0) {

      this.ShareList = _.cloneDeep(this.dummyShareList);
      return
    }
    var data = _.filter(self.dummyShareList, function (contact) {
      var a = contact.user.name;
      var p = a.toLowerCase();

      return p.includes(e)
    })

    this.ShareList = data;


  }

  removeSearchResult() {
    this.searchContact = '';
    this.ShareList = this.dummyShareList;

  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/export/export.component.ts